import React from "react";

function LinkedInIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M0 3.39c0-.773.27-1.41.81-1.912C1.352.976 2.055.725 2.92.725c.85 0 1.537.247 2.062.741.54.51.81 1.174.81 1.993 0 .741-.262 1.359-.787 1.853-.54.51-1.251.764-2.131.764h-.024c-.849 0-1.536-.254-2.061-.764C.263 4.802 0 4.162 0 3.389zm.301 20.27V8.185h5.143V23.66H.301zm7.992 0h5.143v-8.642c0-.54.062-.957.186-1.25a3.36 3.36 0 01.984-1.333c.44-.362.992-.544 1.657-.544 1.73 0 2.594 1.166 2.594 3.498v8.27H24v-8.872c0-2.286-.54-4.02-1.622-5.2-1.08-1.182-2.51-1.773-4.285-1.773-1.993 0-3.545.857-4.657 2.571v.047h-.023l.023-.047v-2.2H8.293c.031.494.047 2.03.047 4.61 0 2.579-.016 6.2-.047 10.865z"
      ></path>
    </svg>
  );
}

export default LinkedInIcon;
